export const REQUEST_NEW = 1;
export const REQUEST_URGENT = 2;
export const REQUEST_INFOR = 3;
export const CATEGORY_ID = 1;

export const USE_REQUEST_NEW = 'USE_REQUEST_NEW';
export const USE_REQUEST_URGENT = 'USE_REQUEST_URGENT';
export const USE_REQUEST_INFOR = 'USE_REQUEST_INFOR';
